<template>
  <div>
    <template v-if="!checkingAccount">
      <c-row class="my-2" v-if="!canAddSites">
        <c-col>
          <c-container fluid class="d-flex content-center">
            <div style="max-width: 800px" class="text-left">
              <c-row>
                <c-col sm="3">
                  <c-img src="/img/logos/koala-large.svg" style="width:100%" />
                </c-col>
                <c-col sm="9">
                  <template v-if="!cardSaved && trialPeriodOver">
                    <h2 class="h4 mt-3">Your 12 month free tier has expired. It started on {{ trialStarted }} ({{ accountAge }} days ago).</h2>
                    <p>The sites that were in your 12 month free tier are now billable sites. You'll need to add a valid credit card in order to continue using KoalaBoss.</p>
                  </template>
                  <template v-else>
                    <h2 class="h4 mt-3">Your free tier is now full (you have {{ freeSiteLimit }} sites in KoalaBoss).</h2>
                    <p>You'll need to add a valid credit card in order to add sites to KoalaBoss.</p>
                  </template>
                  <c-row>
                    <c-col sm="12">
                      <c-button color="primary" to="/my-organisation">Update your billing details</c-button>
                    </c-col>
                    <c-col sm="12" class="mt-3">
                      <a href="https://koalaboss.com/pricing" target="_blank">See our pricing page</a>
                    </c-col>
                  </c-row>
                </c-col>
              </c-row>
            </div>
          </c-container>
        </c-col>
      </c-row>
      <template v-else>
        <c-row>
          <c-col cols="12">
            <c-container fluid class="d-flex content-center">
              <c-card class="p-4" style="max-width: 800px">
                <c-card-body>
                  <c-row>
                    <c-col cols="12" md="6">
                      <modern-monitor v-if="screenshotUrl" :screenshot-url="screenshotUrl" />
                      <img v-else src="/img/logos/koala-large.svg" style="height: 180px" />
                      <h1 class="h4 mt-3">{{ message || defaultMessage }}</h1>
                    </c-col>
                    <c-col cols="12" md="6" class="px-5 text-left">
                      <add-a-new-site @screenshotUrl="screenshotUrl = $event" @update:message="message = $event" />
                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>
            </c-container>
          </c-col>
        </c-row>
        <c-row class="my-2">
          <c-col>
            <c-container fluid class="d-flex content-center">
              <div style="max-width: 800px" class="text-left">
                <a class="float-right pa-5 cursor-pointer" @click="showAddSiteManual = !showAddSiteManual">
                  {{ showAddSiteManual ? 'Hide instructions' : 'Or add site manually' }}
                </a>
              </div>
            </c-container>
          </c-col>
        </c-row>
        <c-row class="mt-4">
          <c-col>
            <c-container fluid class="d-flex content-center">
              <div style="max-width: 800px" class="text-left">
                <manually-add-site-instructions v-if="showAddSiteManual" />
              </div>
            </c-container>
          </c-col>
        </c-row>
      </template>
    </template>
    <template v-else>
      <p>Checking</p>
    </template>
  </div>
</template>

<script>
import AddANewSite from '../site/add-new-site';
import ModernMonitor from '@/views/components/plugin-install/ModernMonitor';
import ManuallyAddSiteInstructions from '@/views/components/dashboard/ManuallyAddSiteInstructions';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'AddNewSite',
  components: {
    AddANewSite,
    ModernMonitor,
    ManuallyAddSiteInstructions,
  },
  props: {
    defaultMessage: String,
  },
  data() {
    return {
      checkingAccount: true,
      canAddSites: false,
      cardSaved: false,
      trialPeriodOver: false,
      accountAge: 0,
      sitesRemaining: 0,
      freeSiteLimit: 0,
      trialStarted: '',
      message: '',
      showAddSiteManual: false,
      screenshotUrl: '',
    };
  },
  mounted() {
    this.checkCanAddSites();
  },
  methods: {
    checkCanAddSites() {
      this.error = null;
      this.checkingAccount = true;
      this.$http
        .get(buildEndpoint('organisation/check/add-sites'))
        .then((response) => {
          const { data } = response.data;
          // this.canAddSites = false;
          this.canAddSites = data.canAddSites;
          // this.cardSaved = false;
          this.cardSaved = data.cardSaved;
          this.trialPeriodOver = data.trialPeriodOver;
          this.accountAge = data.accountAge;
          this.trialStarted = data.trialStarted;
          this.sitesRemaining = data.sitesRemaining;
          this.freeSiteLimit = data.freeSiteLimit;
        })
        .catch((error) => {
          // this.error = error;
        }).finally(() => {
          this.checkingAccount = false;
        });
    },
  },
};
</script>
